export default "__VITE_ASSET__NT$kGleZ__"